export class ActivityLog {
  constructor(data = {}) {
    this.id = data.id || null;
    this.shopName = data.shopName || 'Az Tires';
    this.action = data.action || 'CREATED';
    this.itemName = data.itemName || '';
    this.itemBrand = data.itemBrand || '';
    this.itemCategory = data.itemCategory || '';
    this.details = data.details || '';
    this.timestamp = data.timestamp || Date.now();
    this.discountAmount = data.discountAmount || 0;
    this.quantitySold = data.quantitySold || 0;
    this.itemCost = data.itemCost || 0;
    this.saleAmount = data.saleAmount || 0;
  }

  // Convert to Firestore format
  toFirestore() {
    return {
      shopName: this.shopName,
      action: this.action,
      itemName: this.itemName,
      itemBrand: this.itemBrand,
      itemCategory: this.itemCategory,
      details: this.details,
      timestamp: this.timestamp,
      discountAmount: this.discountAmount || 0,
      quantitySold: this.quantitySold || 0,
      itemCost: this.itemCost || 0,
      saleAmount: this.saleAmount || 0
    };
  }

  // Create from Firestore document
  static fromFirestore(doc) {
    const data = doc.data();
    return new ActivityLog({
      id: doc.id,
      ...data,
      timestamp: data.timestamp?.toMillis?.() || data.timestamp || Date.now()
    });
  }
}